<template>
  <div>
    <booking-data-table/>
  </div>
</template>

<script>
import BookingDataTable from "../components/BookingDataTable.vue"
export default {
  components: {
    "booking-data-table": BookingDataTable
  }
}
</script>

<style>

</style>